import PropTypes from 'prop-types';
import React from 'react';
import { LoginPendingTag, LoginSuccessfulTag } from '../../Tag/library';

export const LoginStatus = (props) => {
  let value;
  if (typeof props === 'string') {
    value = props;
  } else if (typeof props.cell.value === 'string') {
    value = props.cell.value;
  }

  switch (value.toLowerCase()) {
    case 'successful':
      return <LoginSuccessfulTag />;
    case 'pending':
      return <LoginPendingTag />;
    default:
      return <></>;
  }
};

LoginStatus.propTypes = {
  cell: PropTypes.object.isRequired,
};
